import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaChatBubbleProps {
  backgroundColor?: 'tertiary';
}

export interface AhaChatBubbleElement extends HTMLElement, AhaChatBubbleProps {}

/**
 * aha-chat-bubble is a component that displays a chat message.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-chat-bubble',
  styleUrl: 'aha-chat-bubble.css',
  shadow: true,
})
export class AhaChatBubble {
  @Element() host!: HTMLAhaChatBubbleElement;
  @Prop() backgroundColor?: 'tertiary';
  render() {
    return (
      <Host>
        <span>
          <slot></slot>
        </span>
      </Host>
    );
  }
}
